import { get } from 'lodash';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Field, reduxForm, SubmissionError } from 'redux-form';

import RenderField from '../../components/RenderField';
import {
    setOTPVerified,
    setStepNumber,
    updateValidationEmail,
    verifyOTPRequest,
} from '../../store/signup/signupAction';
import { emailValidator } from '../../utilities/validations';
import OtpForm from './OtpForm';
import Loader from '../../components/Loader';

import './Validate.scss';

/**
 * validate component
 * @param {*} param0
 */
const Validate = ({
    currentStep,
    basicData,
    handleSubmit,
    pristine,
    reset,
    submitting,
    setStepNumber,
    updateValidationEmail,
    verifyOTPRequest,
    menu,
    setOTPVerified,
    resendOTP,
    needMailServer,
    needDomain,
    otpVerified,
}) => {
    const history = new useHistory();
    const [changeEmailFlag, setChangeEmailFlag] = useState(false);
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        if (!basicData) {
            setStepNumber(1);
            history.push('/registration');
        }
    }, [basicData, history, setStepNumber]);

    const changeEmail = () => {
        setChangeEmailFlag(true);
    };
    /**
     * Update email function
     * @param {*} formData
     */
    const updateEmail = (formData) => {
        if (formData.email === basicData.email) {
            throw new SubmissionError({
                email: 'Please choose a different Email',
                _error: 'Email update failed',
            });
        }
        setShowLoader(true);
        updateValidationEmail({
            ...formData,
            formID: get(basicData, 'form_id'),
        }).then((res) => {
            setShowLoader(false);
            res.status === 'success' && setChangeEmailFlag(false);
        });
    };
    /**
     * OTP verification component
     */
    const verifyOTP = (formData) => {
        setShowLoader(true);
        return verifyOTPRequest({
            ...formData,
            mailServer: needMailServer,
            needDomain,
            formID: get(basicData, 'form_id'),
        }).then((res) => {
            setShowLoader(false);
            if (res.status === 'failed') {
                throw new SubmissionError({
                    otp: 'OTP entered is invalid',
                    _error: 'verification failed',
                });
            } else {
                // verified

                setOTPVerified(true);
            }
        });
    };
    /**
     * Change email form render
     */
    const changeEmailForm = () => {
        return (
            <form onSubmit={handleSubmit(updateEmail)}>
                <div className="form-group input-btn-group ty1">
                    <Field
                        name="email"
                        component={RenderField}
                        type="email"
                        label="Enter the new email"
                        placeholder="Email"
                        className="form-control"
                        validate={emailValidator}
                    />
                    <button
                        type="submit"
                        disabled={pristine || submitting}
                        className={`btn-tertiary ${
                            pristine || (submitting && 'off')
                        }`}
                    >
                        Submit
                    </button>
                    <button
                        type="button"
                        disabled={submitting}
                        onClick={() => setChangeEmailFlag(false)}
                        className="btn-close-icon"
                    ></button>
                </div>
            </form>
        );
    };
    return (
        <div className="content validate">
            {showLoader && <Loader />}

            <div className="content-block-right">
                {otpVerified ? (
                    <>
                        <div className="sec-header-block">
                            <h1>Validate</h1>
                        </div>
                        <div className="form-block">
                            <span>
                                You have successfully verified your email
                                address.
                            </span>
                            <br />
                            <span>Please click "Next" to continue.</span>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="sec-header-block">
                            <h1>Validate</h1>

                            <p>
                                An email with a verification code has been sent
                                to <br />
                                <b>{get(basicData, 'email', '-')}</b>
                                <button
                                    className="btn-link"
                                    onClick={changeEmail}
                                >
                                    Change Email
                                </button>
                            </p>
                        </div>
                        <div className="form-block inf-validate-group">
                            {changeEmailFlag && changeEmailForm()}
                            <>
                                <OtpForm
                                    disableForm={changeEmailFlag}
                                    verifyOTP={verifyOTP}
                                    otpVerified={otpVerified}
                                />
                            </>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (store) => ({
    currentStep: store.signupReducer.currentStep,
    basicData: get(store, 'signupReducer.basicData'),
    menu: get(store, 'menuReducer.navMenu', []),
    needDomain: get(store, 'signupReducer.needDomain'),
    needMailServer: get(store, 'signupReducer.needMailServer'),
    otpVerified: get(store, 'signupReducer.otpVerified'),
});
const mapDispatchToProps = {
    setStepNumber,
    updateValidationEmail,
    verifyOTPRequest,
    setOTPVerified,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: 'emailUpdateForm', // a unique identifier for this form
    })(Validate)
);
